import React from "react";
import Logo from "../../components/Logo";
import { motion } from "framer-motion";
import { useState, useEffect } from "react";
import apiService from "../../services/ApiService";
import RecursiveTopicSelector from "../../components/RecursiveTopicSelector";
import TailwindButton from "../../components/Tailwind/TailwindButton";
import { cn } from "../../lib/utils";

let easing = [0.6, -0.05, 0.01, 0.99];
const fadeInUp = {
  initial: {
    y: 40,
    opacity: 0,
    transition: { duration: 0.6, ease: easing },
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.6,
      ease: easing,
    },
  },
};

export interface Model {
    id: string,
    name: string,
}

interface Topic {
    name: string,
    models: Model[],
    shared_models: Model[],
    subtopics: Topic[]
}

interface ContactResponse {
    topics: string[],
    modelId: string,
    description: string,
}

// Alert Component
interface AlertProps {
  children: React.ReactNode;
  variant: 'success' | 'error' | 'warning' | 'info' | '';
  className?: string;
}

const Alert: React.FC<AlertProps> = ({ children, variant, className }) => {
  if (!variant) return null;

  const variantClasses = {
    success: 'bg-green-50 border-green-200 text-green-800',
    error: 'bg-red-50 border-red-200 text-red-800',
    warning: 'bg-yellow-50 border-yellow-200 text-yellow-800',
    info: 'bg-blue-50 border-blue-200 text-blue-800',
    '': ''
  };

  const iconMap = {
    success: 'check_circle',
    error: 'error',
    warning: 'warning',
    info: 'info',
    '': ''
  };

  return (
    <div className={cn(
      'flex items-center gap-2 px-4 py-3 rounded-lg border text-sm font-medium',
      variantClasses[variant],
      className
    )}>
      {variant && (
        <span className="material-symbols-outlined text-[20px]">
          {iconMap[variant]}
        </span>
      )}
      <span>{children}</span>
    </div>
  );
};

export default function Contact({  }) {
    const[formContact, setFormContact] = useState<Topic[]>([]);
    const[selectedTopic, setSelectedTopic] = useState<ContactResponse>();
    const[isSubmitting, setIsSubmitting] = useState(false);
    const[displayError, setDisplayError] = useState({
        message: '',
        variant: ''
    });
    const[reset, setReset] = useState(false);

    const sendFormContact = () => {
        setIsSubmitting(true)
        apiService.sendFormContact(selectedTopic.topics, selectedTopic.modelId, selectedTopic.description).then(async(response) => {
            if (response) {
                setIsSubmitting(false)
                if (response.ok)
                {
                    setSelectedTopic((prevState) => {
                        return {
                            ...prevState,
                            description: '',
                        };
                    })
                    setDisplayError({
                        message: "Feedback sent successfully",
                        variant: 'success'
                    })
                }
            }
        })
    }

    useEffect(() => {
    const loadFormContact = () => {
        apiService.getFormContact().then(async(response) => {
            if (response) {
                const elem = await response.json();
                setFormContact(elem)
            }
        })
    }
    loadFormContact()
    }, [])

  return (
    <div className="bg-white h-full grid place-items-center">
      <div className="w-full max-w-[640px]">
        <div className="max-w-[480px] p-6 mx-auto flex justify-center flex-col">
            <div
              className="text-center"
              {...fadeInUp}
              // @ts-ignore
              component={motion.div}
            >
                <Logo />
                <div>
                    <div>
                        <div className="flex justify-center items-center">
                          <h2 className="font-bold text-xl mb-4 text-center">
                            Give us a feedback
                          </h2>
                        </div>
                            {
                                formContact.length ?
                                <div className="mb-12">
                                    <RecursiveTopicSelector
                                    topics={formContact}
                                    level={0}
                                    setSelectedTopic={setSelectedTopic}
                                    selectedTopic={selectedTopic}
                                    setDisplayError={setDisplayError}
                                    reset={reset}
                                    />
                                    {displayError.message ? (
                                      <Alert
                                        variant={displayError.variant as 'success' | 'error' | 'warning' | 'info'}
                                        className="mt-4"
                                      >
                                        {displayError.message}
                                      </Alert>
                                    ) : null}
                                    <div className="mt-5 flex justify-center">
                                        <TailwindButton
                                        fullWidth
                                        size="lg"
                                        onClick={sendFormContact}
                                        disabled={isSubmitting || (selectedTopic ? selectedTopic.description == '' || selectedTopic.description == null ? true : false : true)}
                                        className={cn(
                                          "bg-black hover:bg-black/90 text-white mb-5",
                                          isSubmitting && "opacity-70 cursor-wait"
                                        )}
                                        >
                                            {isSubmitting ? (
                                              <>
                                                <span className="material-symbols-outlined animate-spin text-[20px]">
                                                  progress_activity
                                                </span>
                                                Validating...
                                              </>
                                            ) : (
                                              'Validate'
                                            )}
                                        </TailwindButton>
                                    </div>
                                </div>
                                :
                                <div></div>
                            }
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
}
